import dashboard from './dashboard';
import documents from './documents';
// import pages from './pages';
import fundManagers from './fundManagers';
import reports from './reports';
import suppliers from './suppliers';
import investors from './investors';
import support from './support';
import admins from './admins';
import crm from './crm';
import announcements from './Announcements';
import deals from './deals';
import subscription from './subscription';
import roles from './roles';
import messages from './messages';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    fundManagers,
    investors,
    crm,
    deals,
    admins,
    roles,
    suppliers,
    reports,
    subscription,
    announcements,
    messages,
    support
  ]
  // items: [dashboard, fundManagers, investors, crm, deals, admins, suppliers, documents, reports, announcements, support]
};

export default menuItems;
